import { Container } from "@mantine/core";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_private/dashboard/_trucks/caminhoes")({
  component: RouteComponent
});

function RouteComponent() {
  return (
    <Container size="2xl">
      <Outlet />
    </Container>
  );
}
